import styled from 'styled-components';
import { isTransparentColor, Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSocialFeedSettings } from '../../utils';
import {
  HeaderAvatar,
  HeaderCounters,
  HeaderFollowButton,
  HeaderNames
} from '../components';
import { useHeaderDisplayLogic } from '../helpers';

export function Desktop() {
  const { headerBackgroundColor } = useSocialFeedSettings();

  const {
    shouldShowAvatar,
    shouldShowFollowButton,
    hasAnyName,
    hasAnyCounter
  } = useHeaderDisplayLogic();

  const showNamesOrCounters = hasAnyName || hasAnyCounter;

  const isOnlyButtonVisible =
    shouldShowFollowButton &&
    !shouldShowAvatar &&
    !hasAnyName &&
    !hasAnyCounter;

  const isContainerCentered =
    isTransparentColor(headerBackgroundColor) ||
    !shouldShowFollowButton ||
    isOnlyButtonVisible;

  const isWrapperCentered = !shouldShowAvatar && !shouldShowFollowButton;

  return (
    <Container $isCentered={isContainerCentered}>
      <Show when={shouldShowAvatar || showNamesOrCounters}>
        <Content>
          <Show when={shouldShowAvatar}>
            <HeaderAvatar />
          </Show>

          <Show when={showNamesOrCounters}>
            <NamesAndCounters $isCentered={isWrapperCentered}>
              <Show when={hasAnyName}>
                <HeaderNames />
              </Show>
              <Show when={hasAnyCounter}>
                <HeaderCounters />
              </Show>
            </NamesAndCounters>
          </Show>
        </Content>
      </Show>

      <Show when={shouldShowFollowButton}>
        <HeaderFollowButton />
      </Show>
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'header-desktop',
    element: 'container'
  })
})<{
  $isCentered: boolean;
}>`
  max-width: 100%;
  width: ${({ $isCentered }) => ($isCentered ? 'auto' : '100%')};
  display: flex;
  align-items: center;
  gap: 32px;
  justify-content: ${({ $isCentered }) =>
    $isCentered ? 'center' : 'space-between'};
`;

const Content = styled.div.attrs({
  className: createReadableClass({
    component: 'header-desktop',
    element: 'content'
  })
})`
  display: flex;
  gap: 12px;
  overflow: hidden;
`;

const NamesAndCounters = styled.div.attrs({
  className: createReadableClass({
    component: 'header-desktop',
    element: 'names-and-counters'
  })
})<{
  $isCentered: boolean;
}>`
  display: flex;
  gap: 4px;
  max-width: 100%;
  align-items: ${({ $isCentered }) => ($isCentered ? 'center' : 'flex-start')};
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;
